import axios from 'axios';
import { message } from 'antd';

const instance = axios.create();

// 响应拦截器
instance.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response?.status) {
      switch (error.response.status) {
        // 404请求不存在
        case 404:
          message.error('网络请求不存在');
          break;
        case 400:
          break;
        case 403:
            break;
        // 其他错误，直接抛出错误提示
        default:
          message.error('服务器错误，请重试！');
      }
      return Promise.reject(error.response);
    }
  }
);

export const jurisdiction = usernmae => {
  return instance.get(`/api/v1/ailab/plugins/?username=${usernmae}`);
};

export const uploadPictures = image => {
  return instance.post(
    '/api/v1/ailab/user_face',
    { image },
    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};

export const deleteCache = () => {
  return instance.post(
    '/api/v1/ailab/delete_user_face_cache',
    {},
    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};

export const getPicture = username => {
  return instance.get('/api/v1/ailab/user_face_cache', {
    headers: {
      Authorization: sessionStorage.getItem('toKen')
    }
  });
};

export const me = () => {
  return instance.get('/api/v1/users/me/', {
    headers: {
      Authorization: sessionStorage.getItem('toKen')
    }
  });
};
export const hasAilabPermission = ({ username, extension_id }) => {
  return instance.get(`/api/v1/ailab/has_ailab_permission?username=${username}&extension_id=${extension_id}`, {
    headers: {
      Authorization: sessionStorage.getItem('toKen')
    }
  });
};

// 训练鸢尾花
export const trainIris = param => {
  return instance.post(
    '/api/v1/ailab/train_iris/',
    { ...param },
    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};

// 查询训练结果
export const getTrainResult = () => {
  return instance.get('/api/v1/ailab/train_iris_lab_result/?type=0', {
    headers: {
      Authorization: sessionStorage.getItem('toKen')
    }
  });
};

/**
 * **** 深度强化学习 ****
 *
 */
// 人类玩游戏保存
export const deepLearn_humanTrain = params => {
  return instance.post(
    '/api/v1/ailab/people_train_deep_learning/',
    { ...params },
    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};
// 人类游戏查询
export const deepLearn_humanTrainResult = params => {
  return instance.get(
    `/api/v1/ailab/people_train_deep_learning/${params}`,

    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};
// 根据传递参数获取预计时间
export const deepLearn_trainTime = params => {
  return instance.post(
    `/api/v1/ailab/train_deep_learning/`,
    { ...params },
    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};
// 深度强化学习点击确定和取消的接口（重新训练）
export const deepLearn_trainCancel_or_Ok = params => {
  return instance.post(
    `/api/v1/ailab/train_deep_learning_cancel_or_ok/`,
    { ...params },
    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};

// 查询是否已有训练模型
export const deepLearn_getTrainModal = params => {
  return instance.get(
    `/api/v1/ailab/train_deep_learning_cancel_or_ok/`,

    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};


/**
 * **** 农作物病虫害识别 ****
 *
 */
export const cropDiseaseRecognition = (image) => {
    return instance.post(
        '/api/v1/ailab/crop_disease_recognition',
        // 'http://localhost:5003/upload',
        {
            image
        },
        {
            headers: {
                Authorization: sessionStorage.getItem('toKen')
            }
        }
    )
}

export const cacheRecognitionImages = () => {
    return instance.get(
        '/api/v1/ailab/crop_disease_cache',
        // 'http://localhost:5003/get_cache',
        {
            headers: {
                Authorization: sessionStorage.getItem('toKen')
            }
        },
    )
}

/**
 * **** 图形识别专家系统 ****
 *
 */
export const pattern_currentRules = params => {
  return instance.get(`/api/v1/ailab/picture_detection?rule_type_id=${params}`, {
    headers: {
      Authorization: sessionStorage.getItem('toKen')
    }
  });
};
export const picture_detection = params => {
  return instance.post(
    `/api/v1/ailab/picture_detection`,
    { ...params },
    {
      headers: {
        Authorization: sessionStorage.getItem('toKen')
      }
    }
  );
};


/**
 * **** 说话人识别 ****
 *
 */
// 上传
export const uploadVoice = formData => {
    return instance.post(
        // 'http://localhost:5003/upload',
        // 'https://api.dev.longan.eliteu.xyz/api/v1/speaker_recognition_upload',
        '/api/v1/ailab/speaker_recognition_upload',
        formData,
        {
            headers: {
                Authorization: sessionStorage.getItem('toKen'),
            }
        }
    )
}

// 训练声纹
export const speakerTraining = formData => {
    return instance.post(
        // 'http://localhost:5003/train',
        // 'https://api.dev.longan.eliteu.xyz/api/v1/speaker_recognition',
        '/api/v1/ailab/speaker_recognition',
        formData,
        {
            headers: {
                Authorization: sessionStorage.getItem('toKen'),
            }
        }
    )
}

// 获取声纹是否已经上传完成
export const getSpeakerTraining = () => {
    return instance.get(
        // 'http://localhost:5003/getTrain',
        // 'https://api.dev.longan.eliteu.xyz/api/v1/speaker_recognition',
        '/api/v1/ailab/speaker_recognition',
        {
            headers: {
                Authorization: sessionStorage.getItem('toKen'),
            }
        }
    )
}

// 删除声纹
export const deleteVoice = () => {
    return instance.post(
        // 'http://localhost:5003/deleteVoice',
        // 'https://api.dev.longan.eliteu.xyz/api/v1/speaker_delete',
        '/api/v1/ailab/speaker_delete',
        {},
        {
            headers: {
                Authorization: sessionStorage.getItem('toKen'),
            }
        }
    )
}


/** textCreateImage **/
export const getDataJson = module => {
    return new Promise((resolve, reject) => {
        fetch(`https://dall-e.eliteu.xyz/dall-e/v2/metadata_zip/${ module }.json`)
            .then(response => response.json())
            .then(data => resolve(data))
            .catch(error => reject('Error fetching JSON:', error));
  })
}

// https://api.dev.longan.eliteu.xyz/api/v1/products/{product_code}/
// 获取版本号
export const getVersion = () => {
  const host = window.location.host;
  if (host.includes('localhost') || host.includes('eliteu.xyz')) {
    return instance.get('https://admin.aiclub.eliteu.xyz/api/v1/products/lab/')
  } else {
    return instance.get('https://admin.aiwanjia.club/api/v1/products/lab/')
  }
}


// 声纹验证
export const getSpeakerVerify = (formData) => {
  return instance.post(
      '/api/v1/ailab/speaker_verify',
      formData,
      {
          headers: {
              Authorization: sessionStorage.getItem('toKen'),
          }
      }
  )
}
// 扩展使用量查询
export const getExtensionLimitSettings = (extensionId) => {
  return instance.get(
      `/api/v1/plugin/extension_limit_settings?platform=lab&extension_id=${extensionId}`,
      {
          headers: {
              Authorization: sessionStorage.getItem('toKen'),
          }
      }
  )
}

// 查询实时天气（含写入使用天气记录）
export const getWeather = (params) => {
  return instance.post(
      `/api/v1/ailab/lab_weather`,
      {...params },
      {
          headers: {
              Authorization: sessionStorage.getItem('toKen'),
          }
      }
  )
}


// 车牌识别
export const carRecognition = (params) => {
  return instance.post(
      `/api/v1/ailab/car_recognition`,
      {...params },
      {
          headers: {
              Authorization: sessionStorage.getItem('toKen'),
          }
      }
  )
}

// 记录语音合成使用情况
export const extendUsetts = (params) => {
  return instance.post(
      `/api/v1/ailab/usetts/`,
      {...params },
      {
          headers: {
              Authorization: sessionStorage.getItem('toKen'),
          }
      }
  )
}

// 记录语音合成使用情况
export const vegetableDetect = (params) => {
  return instance.post(
      '/api/v1/ailab/vegetable_detect',
      params,
      {
          headers: {
              Authorization: sessionStorage.getItem('toKen'),
          }
      }
  )
}
// 完整/实时语音识别
export const speech2Recognition = (formData) => {
  return instance.post(
      '/api/v1/ailab/lab_speech2_recognition',
      formData,
      {
          headers: {
              Authorization: sessionStorage.getItem('toKen'),
          }
      }
  )
}

 // 文本分组发送函数
export const sendTextInChunks = (text, cb, seconds = 1000) => {
        const maxChunkSize = 60; // 每组最大60个字符
        const chunks = []
        // 将文本按120个字符分组
        for (let i = 0; i < text.length; i += maxChunkSize) {
            chunks.push(text.slice(i, i + maxChunkSize))
        }
        chunks.forEach((content, index) => {
            setTimeout(() => {
                // sendMessage({
                //     [messageId]: {
                //         content,
                //         index: index + 1,
                //         total: chunks.length
                //     }
                // });
                cb(content, index + 1, chunks.length)
            }, index * seconds) // 每个消息间隔1秒发送
        })
    }
// export const sendTextInChunks = async (text, cb, interval = 200) => {
//   const encoder = new TextEncoder();
//   const bytes = encoder.encode(text);
//   const maxChunkSize = 100; // 实测可安全使用的最大字节数（建议 ≤ 100）
//   const total = Math.ceil(bytes.length / maxChunkSize);

//   for (let i = 0; i < total; i++) {
//     const chunk = bytes.slice(i * maxChunkSize, (i + 1) * maxChunkSize);
//     const content = new TextDecoder().decode(chunk); // 转回字符串（可选）
//     await cb(content, i + 1, total);
//     await new Promise((r) => setTimeout(r, interval));
//   }
// };
